export default __webpack_public_path__ + "static/media/adidas-K.a5364144.png";